import classes from "./text.module.css";

export type TextProps = {
	title: string;
	paragraphs: { type: string; text: string }[];
};

export const Text = ({ title, paragraphs }: TextProps) => (
	<section className={classes.text}>
		<h3>{title}</h3>
		{paragraphs.map((paragraph, index) =>
			paragraph.type === "text-pre" ? (
				<pre key={index}>{paragraph.text}</pre>
			) : paragraph.type === "headline" ? (
				<h4 className={classes.headline}>{paragraph.text}</h4>
			) : (
				<p>{paragraph.text}</p>
			)
		)}
	</section>
);
